export const areObjectsEqual = (obj1, obj2) => {
  // Check if both parameters are objects
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }
  if (obj1 === null && obj2 === null || obj1 === undefined && obj2 === undefined) {
    return true;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if all keys are the same
  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }

    // Recursively check nested objects or arrays
    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      if (!areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    } else if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  // Objects are equal
  return true;
};
export const encodeObjectToQueryString = obj => {
  return encodeURIComponent(JSON.stringify(obj));
};
export const isEmptyObject = obj => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

// 23:00 pm
export const replaceIncorrectAmFM = (str, useSpaceInsteadOfDots) => {
  if (str) {
    const prev = str.replace(" am", "").replace(" pm", "");
    if (useSpaceInsteadOfDots) {
      return prev.replace(":", " ");
    }
    return prev;
  }
  return "";
};
export const randomSortExceptFirst = arr => {
  if (arr.length <= 1) return arr;
  const [first, ...rest] = arr;
  const shuffled = rest.sort(() => Math.random() - 0.5);
  return [first, ...shuffled];
};